// Import GSAP and ScrollTrigger
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import Swiper JS
import Swiper from 'swiper/bundle';

// Import Lenis
import Lenis from '@studio-freight/lenis';

// Import Swup and Swup debug plugin
import Swup from 'swup';
import SwupDebugPlugin from '@swup/debug-plugin';

// Lenisの初期化とスクロール関連処理
const lenis = new Lenis();
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// Lenis smooth scrolling for anchor links, apply offset only if window width is less than 768px
function setupLenisSmoothScroll() {
	// 通常のアンカーリンクに対してLenisのスクロールを適用
	document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
		anchor.addEventListener('click', function (event) {
			const href = this.getAttribute('href');

			// mailtoリンクや外部リンクは無視
			if (href.startsWith('mailto:') || !href.includes('#')) return;

			// リンク先のIDを取得
			const targetId = href.includes('#') ? href.split('#')[1] : null;
			const targetElement = document.getElementById(targetId);

			// リンク先が存在するかチェック
			if (targetElement) {
				event.preventDefault(); // デフォルトのページジャンプを抑制
				let offset = 0;

				if (window.innerWidth < 768) {
					const headerHeight = document.querySelector('header').offsetHeight; // ヘッダーの高さを取得
					offset = -headerHeight; // 768px未満の場合にのみヘッダー分のオフセットを追加
				}
				// Lenisのスクロールを実行
				lenis.scrollTo(targetElement, { offset: offset });
			}
		});
	});
}


// 初回ロード時にLenisのスムーズスクロールをセットアップ
document.addEventListener('DOMContentLoaded', () => {
	setupLenisSmoothScroll();
	initSwiper();
	createScrollTrigger('.fadeUp','top 65%','is-active');
	topLearnBg();
	usageCurrentBg();
	productDetailMap();
	toppageVisited();
	igFeed();
});

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('is-ready');
});

let startPos = 0;
let winScrollTop = 0;
let menuState = false;
let threshold = window.innerHeight; // 100dvhの基準値

window.addEventListener('scroll', function () {
	winScrollTop = window.scrollY;

	if (winScrollTop !== 0) {
		document.body.classList.add('is-scroll');
	} else {
		document.body.classList.remove('is-scroll');
	}

	if (winScrollTop >= startPos) {
		if (winScrollTop >= threshold && !menuState) {
			document.body.classList.add('is-down');
		}
	} else {
		document.body.classList.remove('is-down');
	}
	startPos = winScrollTop;
});

// リサイズイベントで100dvhを再計算
window.addEventListener('resize', function () {
	threshold = window.innerHeight;
});


gsap.registerPlugin(ScrollTrigger);

function createScrollTrigger(selector, start, className, markers = false) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: start,
      toggleClass: { targets: el, className: className },
      once: true,
      markers: markers,
    });
  });
}



// Function to update body class based on main's data-pagename
function updateBodyClass() {
	const mainElement = document.querySelector('main');
	if (mainElement) {
		const pageName = mainElement.dataset.pagename;
		// Update body tag's class
		document.body.className = pageName ? `${pageName}` : '';
	}
}
// Function to add 'is-ready' class when all resources are loaded
function addIsReadyClass() {
	// For first page load
	if (document.readyState === 'complete') {
		document.body.classList.add('is-ready');
	} else {
		window.addEventListener('load', () => {
			document.body.classList.add('is-ready');
		});
	}
}

// SWUPの初期化
const swup = new Swup({
	plugins: [new SwupDebugPlugin()],
	linkSelector: 'a:not(.no-swup)'
});


// Function to add 'is-ready' class after Swup content replacement
function addIsReadyClassAfterTransition() {
	document.body.classList.add('is-ready');
}

// Function to remove 'is-ready' class (called on visit:start)
function removeIsReadyClass() {
	document.body.classList.remove('is-ready');
}

// SWUP initialization function (formerly init)
function swupinit() {
	// Add body class update
	updateBodyClass();

	// Add 'is-ready' class when all resources are loaded
	addIsReadyClass();
}

// Use visit:start hook to update body class and remove 'is-ready'
swup.hooks.on('visit:start', () => {
	removeIsReadyClass();
	updateBodyClass();
});

// Add 'is-ready' class after the new content has finished animating in
swup.hooks.on('animation:in:end', () => {
	addIsReadyClassAfterTransition();
});

// Run swupinit on DOMContentLoaded
if (document.readyState === 'complete') {
	swupinit();
} else {
	document.addEventListener('DOMContentLoaded', () => swupinit());
}

// SWUP hooks
swup.hooks.on('page:view', () => swupinit());

swup.hooks.on("visit:start", () => {
	ScrollTrigger.getAll().forEach((t) => t.kill(false));
	ScrollTrigger.refresh();
});

// Add hook for updating body class after content is replaced
swup.hooks.on('content:replace', () => {
	updateBodyClass();
	setupLenisSmoothScroll();
	initSwiper();
	createScrollTrigger('.fadeUp','top 65%','is-active');
	topLearnBg();
	usageCurrentBg();
	productDetailMap();
	toppageVisited();
	igFeed();
});

document.addEventListener('DOMContentLoaded', () => {
	const menuButton = document.getElementById('menuButton');
	const gnav = document.getElementById('gnav');
	let menuState = false;
	let scrollPos;

	menuButton.addEventListener('click', () => {
			menuButton.classList.toggle('show');
			gnav.classList.toggle('show');
			if (!menuState) {
					scrollPos = window.scrollY;
					document.body.classList.add('fixed');
					document.body.style.top = `-${scrollPos}px`;
					menuState = true;
			} else {
					document.body.classList.remove('fixed');
					document.body.style.top = '0';
					window.scrollTo(0, scrollPos);
					menuState = false;
			}
	});

	Array.from(gnav.querySelectorAll('a')).forEach(link => {
			link.addEventListener('click', closeMenu);
	});

	window.addEventListener('load', handleResize);
	window.addEventListener('resize', handleResize);

	document.addEventListener('click', (event) => {
			if (!gnav.contains(event.target) && !menuButton.contains(event.target) && menuState) {
					closeMenu();
			}
	});

	function closeMenu() {
			menuButton.classList.remove('show');
			gnav.classList.remove('show');
			document.body.classList.remove('fixed');
			document.body.style.top = '0';
			window.scrollTo(0, scrollPos);
			menuState = false;
	}

	function handleResize() {
			if (window.innerWidth >= 768) {
					document.body.classList.remove('fixed');
					document.body.style.top = '0';
			}
	}
});

document.addEventListener('DOMContentLoaded', () => {
	const pagetop = document.getElementById('pagetop');
	if (pagetop) {
			pagetop.addEventListener('click', () => {
					lenis.scrollTo(0);
			});
	}

	const gnavAnchors = document.querySelectorAll('.top .gnav-anchor');
	gnavAnchors.forEach(anchor => {
			anchor.addEventListener('click', (e) => {
					e.preventDefault();
					const href = anchor.getAttribute('href');
					const id = href.replace('/', '');
					lenis.scrollTo(id);
			});
	});
});


const initSwiper = function () {
	const swiper = new Swiper('#lineupSwiper', {
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		},
		speed: 1000,
		centeredSlides: true,
		slidesPerView: 'auto',
		breakpoints: {
			768: {
				slidesPerView: 8,
				centeredSlides: false,
			},
			1600: {
				slidesPerView: 10,
				centeredSlides: false,
			}
		}
	});
}

const topLearnBg = function () {
	if('#topLearnBg')
	gsap.timeline({
		scrollTrigger: {
			trigger: ".topLearn",
			start: "top 35%",
			end: "bottom 30%",
			scrub: true,
		}
	})
	.set("#topLearnBg", {opacity:0})
	.to("#topLearnBg", {opacity:1, duration:0.4})
	.to("#topLearnBg", {opacity:1, duration:0.3})
	.to("#topLearnBg", {opacity:0, duration:0.3});
}

const usageCurrentBg = function () {
	if('#usageCurrentBg')
	gsap.timeline({
		scrollTrigger: {
			trigger: ".usageCurrent",
			start: "top 35%",
			end: "bottom 30%",
			scrub: true,
		}
	})
	.set("#usageCurrentBg", {opacity:0})
	.to("#usageCurrentBg", {opacity:1, duration:0.4})
	.to("#usageCurrentBg", {opacity:1, duration:0.3})
	.to("#usageCurrentBg", {opacity:0, duration:0.3});
}

/*
const topMvCover = function () {
	if('#topMvCover')
	gsap.timeline({
		scrollTrigger: {
			trigger: ".topLead",
			start: "top 100%",
			end: "top 0%",
			scrub: true,
			markers: false
		}
	})
	.set("#topMvCover", {opacity:0})
	.to("#topMvCover", {opacity:1, duration:0.3});
}
const topLead = function () {
	if('#topLeadBlock')
	gsap.timeline({
		scrollTrigger: {
			trigger: "#topLeadBlock",
			start: "top -20%",
			end: "bottom bottom",
			scrub: true,
			markers: false
		}
	})
	.set(".topLead .image", {opacity:0})
	.to(".topLead .image", {opacity:1});
	gsap.timeline({
		scrollTrigger: {
			trigger: "#topLeadBlock",
			start: "top top",
			end: "bottom bottom",
			scrub: true,
			markers: false
		}
	})
	.set(".topLead .inner", {opacity:0})
	.to(".topLead .inner", {opacity:1});
	gsap.timeline({
		scrollTrigger: {
			trigger: "#topLeadBlock",
			start: "top -50%",
			end: "bottom bottom",
			scrub: true,
			markers: false
		}
	})
	.fromTo(".topLead .bg", 
		{ opacity: 0 }, 
		{ opacity: 1, duration: 1 }
	);
}
	*/
/*
const productAreaPin = function () {
	const productArea = document.querySelector('.productArea');
	const productAreaBg = document.querySelector('#productAreaBg');
	if (productArea) {
		// 全体のカバー
		gsap.timeline({
			scrollTrigger: {
				trigger: productArea,
				start: "top center",
				end: "top -50%",
				scrub: true,
				markers: false
			}
		})
		.set(productAreaBg, {opacity:0})
		.to(productAreaBg, {opacity:1, duration:0.5})
		.to(productAreaBg, {opacity:0, duration:0.5});
		// テキスト
		gsap.timeline({
			scrollTrigger: {
				trigger: productArea,
				start: "top top",
				end: "bottom center",
				scrub: true,
				markers: false
			}
		})
		.set(productArea.querySelectorAll('.texts'), {opacity:0})
		.to(productArea.querySelectorAll('.texts'), {opacity:1});
		// sp背景
		gsap.timeline({
			scrollTrigger: {
				trigger: productArea,
				start: "top -20%",
				end: "bottom top",
				scrub: true,
				markers: false
			}
		})
		.set(productArea.querySelector('.bg_sp'), {opacity:0})
		.to(productArea.querySelector('.bg_sp'), {opacity:1});
		// pc背景
		gsap.timeline({
			scrollTrigger: {
				trigger: productArea,
				start: "top -20%",
				end: "bottom top",
				scrub: true,
				markers: false
			}
		})
		.set(productArea.querySelector('.bg_pc'), {opacity:0})
		.to(productArea.querySelector('.bg_pc'), {opacity:1});
		// リンク
		gsap.timeline({
			scrollTrigger: {
				trigger: productArea,
				start: "bottom 50%",
				end: "bottom -10%",
				scrub: true,
				markers: false
			}
		})
		.set(productArea.querySelector('.links'), {opacity:0})
		.to(productArea.querySelector('.links'), {opacity:1});
		// 全体のフェードアウト
		gsap.timeline({
			scrollTrigger: {
				trigger: productArea,
				start: "bottom -30%",
				end: "bottom -100%",
				scrub: true,
				markers: false
			}
		})
		.set(productArea, {opacity:1})
		.to(productArea, {opacity:0});
	}
}
*/
const productDetailMap = function () {
	const target = document.querySelector('.productDetailMap .map');
	if (target) {
		const bg = target.querySelector('.bg');
		const marker = target.querySelector('.marker');
		const smoke = target.querySelector('.smoke');
		ScrollTrigger.create({
			trigger: target,
			start: "top 10%",
			toggleClass: {targets: bg, className: "is-active"},
			once: true,
    });
		ScrollTrigger.create({
			trigger: target,
			start: "top 10%",
			toggleClass: {targets: marker, className: "is-active"},
			once: true,
    });
		ScrollTrigger.create({
			trigger: target,
			start: "top 10%",
			toggleClass: {targets: smoke, className: "is-active"},
			once: true,
    });
	}
}


const toppageVisited = function() {
  const topMv = document.querySelector('.topMv');
  const header = document.querySelector('header');

  if (topMv) {
		header.classList.remove('is-active');
		document.querySelector('#topMvLayer1').classList.add('is-active');
		document.querySelector('#topMvLayer2').classList.add('is-active');
		document.querySelector('#topMvLayer3').classList.add('is-active');
		setTimeout(() => {
			header.classList.add('is-active');
			sessionStorage.setItem('isToppageVisited', 'true');
		}, 3500);

		window.addEventListener('scroll', () => {
			const triggerHeight = topMv.offsetHeight * 1.5;
			if (window.scrollY > triggerHeight) {
				topMv.classList.add('is-hide');
			} else {
				topMv.classList.remove('is-hide');
			}
		});
  }
};

const toppageVisitedBK = function() {
  const topMv = document.querySelector('.topMv');
  const header = document.querySelector('header');

  if (topMv) {
    if (sessionStorage.getItem('isToppageVisited') === 'true') {
      // 2回目以降の訪問
			document.querySelector('#topMvLayer1').remove();
      document.querySelector('#topMvLayer2').remove();
      document.querySelector('#topMvLayer3').remove();
      if (header) {
        header.classList.add('is-active');
      }
    } else {
      // 初回訪問
      document.querySelector('#topMvLayer1').classList.add('is-active');
      document.querySelector('#topMvLayer2').classList.add('is-active');
      document.querySelector('#topMvLayer3').classList.add('is-active');
      setTimeout(() => {
        header.classList.add('is-active');
        sessionStorage.setItem('isToppageVisited', 'true');
      }, 3500);

      window.addEventListener('scroll', () => {
        const triggerHeight = topMv.offsetHeight * 1.5;
        if (window.scrollY > triggerHeight) {
          topMv.classList.add('is-hide');
        } else {
          topMv.classList.remove('is-hide');
        }
      });
    }
  }
};


const igFeed = function(){
	fetch('https://graph.facebook.com/v22.0/17841471407915741?fields=name%2Cmedia.limit(8)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cthumbnail_url%2Cmedia_type%2Cusername%7D&access_token=EAAOHqvhBUzgBO5PytF8uQWI8cWI8PchJZBtoWnWQJqD0ZBERZB0rzRX0OLeeNI8P22N65gZCW1uGG1rTTuu9R7BqtADJCDZAZCPtPsFejdlgA1asUiEL2yJuXAk2ktcFFkCOzkwmo5g0kcKdjLcs4jm74NZCpEEjX7EZBzYSqzjYqjNPOVUJTMxmWQQcSRie6CDtbz02ZBfzV')
	.then(res => res.json())
	.then(json => {
		let html = '';
		const insta = json.media.data;

		insta.forEach(({ media_type, permalink, media_url, thumbnail_url }) => {
			console.log(permalink);
			if (media_type === 'IMAGE' || media_type === 'CAROUSEL_ALBUM') {
				html += `
					<a href="${permalink}" target="_blank" rel="noopener noreferrer">
						<img src="${media_url}" alt="">
					</a>
				`;
			} else if (media_type === 'VIDEO') {
				html += `
					<a href="${permalink}" target="_blank" rel="noopener noreferrer">
						<img src="${thumbnail_url}" alt="">
					</a>
				`;
			}
		});

		document.querySelector('.igArea .feed').insertAdjacentHTML('beforeend', html);
	})
	.catch(err => {
		console.error(err);
	});

}